import _ from 'lodash';

import shuffleSeed from 'shuffle-seed';

import PropTypes from 'prop-types';

import { cmsService } from '../../services/homii-services';

import HeroSection from '../../components/live-page-components/hero-section.component';
import BestLifeSection from '../../components/live-page-components/best-life-section.component';
import VideoSection from '../../components/live-page-components/video-section.component';
import ChooseSection from '../../components/live-page-components/choose-section.component';
import OptionsSection from '../../components/live-page-components/options-section.component';
import HOMiiLifeSection from '../../components/live-page-components/homii-life-section.component';
import CityCarousel from '../../components/city-carousel/city-carousel.component';

import MobileAppSection from '../../components/home-page-components/mobile-app-section.component';

import {
    Layout,
    Footer,
    MetaData,
    FadeInAnimation,
} from '../../components/shared';


import GalleryCarousel from '../../components/gallery/gallery-carousel.component';
import { cityDomain } from '../../domain';
import GalleryCarouselMobile from '../../components/gallery/gallery-carousel-mobile.component';
import useResponsive from '../../../utils/responsive';

const SEED = 'HOMiiVal';

const LiveYourBestLife = (props) => {        
    const { data, baseUrlApp, gallery, cities } = props;
    const seoTitle = _.get(data, 'acf.seo_title');
    const seoMetaDesc = _.get(data, 'acf.seo_meta_description');
    const heroTitle = _.get(data, 'acf.hero_title');
    const heroSubHeading = _.get(data, 'acf.hero_sub_heading');
    const heroParagraph = _.get(data, 'acf.hero_paragraph');
    const heroParagraphTwo = _.get(data, 'acf.hero_paragraph_two');
    const heroImgSrc = _.get(data, 'acf.hero_main_image');
    const heroImgAlt = _.get(data, 'acf.hero_main_image_alt');
    const bestLifeTitle = _.get(data, 'acf.best_life_section_title');
    const bestLifeParagraph = _.get(data, 'acf.best_life_section_paragraph');
    const videoTitle = _.get(data, 'acf.video_title');
    const videoUrl = _.get(data, 'acf.video_url');
    const chooseTitle = _.get(data, 'acf.choose_section_title');
    const chooseSubHeading = _.get(data, 'acf.choose_section_sub_heading');
    const chooseParagraph = _.get(data, 'acf.choose_section_paragraph');
    const chooseIcons = _.get(data, 'acf.choose_section_icons');
    const chooseImg = _.get(data, 'acf.choose_section_main_image.url');
    const chooseImgAlt = _.get(data, 'acf.choose_section_main_image_alt');
    const optionsTitle = _.get(data, 'acf.options_section_title');
    const optionsSubHeading = _.get(data, 'acf.options_section_sub_heading');
    const optionsParagraph = _.get(data, 'acf.options_section_paragraph');
    const optionsIcons = _.get(data, 'acf.option_icons');
    const optionsImg = _.get(data, 'acf.options_section_main_image.url');
    const optionsImgAlt = _.get(data, 'acf.main_image_alt');
    const homiiLifeTitle = _.get(data, 'acf.homii_life_section_title');
    const homiiLifeIcons = _.get(data, 'acf.homii_life_icons');
    const MobileAppMainTitle = _.get(data, 'acf.mobile_app_section_title');
    const mobileAppTitle = _.get(data, 'acf.mobile_title');
    const mobileAppParagraph = _.get(data, 'acf.mobile_paragraph');
    const mobileAppIcon = _.get(data, 'acf.mobile_icon.url');
    const mobileAppIconText = _.get(data, 'acf.mobile_icon_text');
    const mobilePrimaryImgSrc = _.get(data, 'acf.mobile_primary_image.url');
    const mobilePrimaryImgAlt = _.get(data, 'acf.mobile_primary_image_alt');
    const mobileAppSecondaryImgSrc = _.get(data, 'acf.mobile_secondary_image.url');
    const mobileAppSecondaryImgAlt = _.get(data, 'acf.mobile_secondary_image_alt');
    const citiesTitle = _.get(data, 'acf.city_title');
    const citiesParagraph = _.get(data, 'acf.city_paragraph');
    const media = _.get(gallery, 'acf.items');
    const { isMobile } = useResponsive();
    return (

        <Layout>

            <MetaData
                title={seoTitle}
                desc={seoMetaDesc}
                canonical={`${baseUrlApp}/live/live-your-best-life`}
            />

            <div className='corporate-container'>

                <HeroSection
                    title={heroTitle}
                    subheading={heroSubHeading}
                    paragraph={heroParagraph}
                    paragraphTwo={heroParagraphTwo}
                    imgSrc={heroImgSrc}
                    imgAlt={heroImgAlt}
                    id="live_your_best_life_header"
                />

            </div>

            <BestLifeSection title={bestLifeTitle} paragraph={bestLifeParagraph} />

            <VideoSection
                title={videoTitle}
                videoUrl={videoUrl}                
                marginTop={190}
                marginBottom={150}
                marginTopMobile={100}
                marginBottomMobile={80}
            />

            <ChooseSection
                title={chooseTitle}
                subHeading={chooseSubHeading}
                paragraph={chooseParagraph}
                icons={chooseIcons}
                imgSrc={chooseImg}
                imgAlt={chooseImgAlt}
            />

            <OptionsSection
                title={optionsTitle}
                subHeading={optionsSubHeading}
                paragraph={optionsParagraph}
                icons={optionsIcons}
                imgSrc={optionsImg}
                imgAlt={optionsImgAlt}
            />

            {isMobile ? 
                <div className='carousel-container-mobile'>
                    <GalleryCarouselMobile category="All Topics" data={shuffleSeed.shuffle(media, SEED)} inDialog={false} selectedIndex={1} />
                </div>
                :
                <div className='container-root container-root-maxWidthLg blog-carousel-container building-carousel-container-settings'>
                    <div style={{ marginBottom: 183 }}> 
                        <GalleryCarousel category="All Topics" data={shuffleSeed.shuffle(media, SEED)} inDialog={false} selectedIndex={1} />
                    </div>
                </div>
            }

            <HOMiiLifeSection
                title={homiiLifeTitle}
                icons={homiiLifeIcons}
            />

            <div className='live-your-best-carousel-container'>
                <div className='container-root container-root-maxWidthLg city-carousel-container city-carousel-container-calc'>                
                    <CityCarousel
                        title={citiesTitle}
                        paragraph={citiesParagraph}
                        type="FindaSpace"
                        cities={cities}
                    />                
                </div>            
            </div>

            <div className='container-root container-root-maxWidthMd live-your-best-life-container-settings'>
                <FadeInAnimation>
                    <div>
                        <p className='dummy-header-two live-your-best-life-header-two'>{MobileAppMainTitle}</p>
                    </div>
                </FadeInAnimation>
            </div>

           <div className='corporate-container'>

                <MobileAppSection                    
                    title={mobileAppTitle}
                    paragraph={mobileAppParagraph}
                    icon={mobileAppIcon}
                    iconText={mobileAppIconText}
                    primaryImgSrc={mobilePrimaryImgSrc}
                    primaryImgAlt={mobilePrimaryImgAlt}
                    secondaryImgSrc={mobileAppSecondaryImgSrc}
                    secondaryImgAlt={mobileAppSecondaryImgAlt}
                />

            </div>

            <Footer />

        </Layout>

    );
};

export const getServerSideProps = async ({ }) => {    
    const resp = await cmsService.RetrieveWordPressPage('live-your-best-life');
    const respGallery = await cmsService.RetrieveWordPressPage('gallery'); 
    const cities = await cityDomain.fetchAllCitiesData();
    return {
        props: {
            data: resp,
            gallery: respGallery,
            cities
        }
    };
};

export default LiveYourBestLife;

LiveYourBestLife.propTypes = {
    data: PropTypes.object,
    baseUrlApp: PropTypes.string,
    gallery: PropTypes.object,
};

